import React from "react";
import laptop from "../assets/img/laptop.svg";
import chart from "../assets/img/chart.svg";
import phone from "../assets/img/phone.svg";
import globe from "../assets/img/globe.svg"
import pc from "../assets/img/pc.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Container, Row, Col } from "react-bootstrap";
import colorSharp from "../assets/img/color-sharp.png";
import "animate.css";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx animate__animated animate__zoomIn">
              <h2>Skills</h2>
              <p>
                In Buyoi we are able to create high quality custom solutions to meet the needs of our clients in web development, desktop applications and mobile applications. 
                <br></br>We pride ourselves in having a highly skilled and experienced team in the use of different development technologies and in creating efficient and scalable solutions for our clients.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <img src={globe} alt="Image" />
                  <h5>Web Development</h5>
                </div>
                <div className="item">
                  <img src={phone} alt="Image" />
                  <h5>Android/iOS Development</h5>
                </div>
                <div className="item">
                  <img src={pc} alt="Image" />
                  <h5>Desktop Applications</h5>
                </div>
                <div className="item">
                  <img src={chart} alt="Image" />
                  <h5>Database Managment</h5>
                </div>
                <div className="item">
                  <img src={laptop} alt="Image" />
                  <h5>Web Responsive</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
      <img src={colorSharp} alt="Image" className="background-image-left" />
    </section>
  );
};
